import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSlackMessagesForStage as GetSlackMessagesForStageQuery,
    GetSlackMessagesForStageVariables as GetSlackMessagesForStageQueryVariables,
    SlackMessageAutomation as SlackMessageAutomationFragment,
} from 'nutshell-graphql-types';

import GET_SLACK_MESSAGES_FOR_STAGE from '../../graphql/queries/get-slack-messages-for-stage.graphql';

import {SalesAutomationCardSlack} from '../cards/sales-automation-card-slack';

import {CardsContainer} from './cards-container';

type OwnProps = {
    parentId: string;
    hideCards: boolean;
};

type GraphQLProps = {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    slackAutomations: SlackMessageAutomationFragment[];
};

type Props = OwnProps & GraphQLProps;

export class StageCardsSlackMessagesContainerComponent extends React.PureComponent<Props> {
    render() {
        const slackCards = this.props.slackAutomations
            ? this.props.slackAutomations.map((slackAutomation) => {
                  return (
                      <SalesAutomationCardSlack
                          key={slackAutomation.id}
                          parentId={this.props.parentId}
                          slackAutomation={slackAutomation}
                      />
                  );
              })
            : [];

        return (
            <CardsContainer
                type='slack'
                isCardBeingDragged={false} // Can't drag slack automations right now
                isLoading={this.props.isLoading}
                hideAddCard={this.props.hideCards}
                errorMessage={this.props.errorMessage}
                parentId={this.props.parentId}
            >
                {slackCards}
            </CardsContainer>
        );
    }
}

class StageQuery extends Query<
    GetSlackMessagesForStageQuery,
    GetSlackMessagesForStageQueryVariables
> {}

export const StageCardsSlackMessagesContainer = (props: OwnProps) => (
    <StageQuery query={GET_SLACK_MESSAGES_FOR_STAGE} variables={{stageId: props.parentId}}>
        {({data, loading, error, refetch}) => {
            const stage = data ? data.stage : null;

            return (
                <StageCardsSlackMessagesContainerComponent
                    {...props}
                    // @ts-expect-error
                    slackAutomations={stage ? stage.editableSlackMessageAutomations : undefined}
                    isLoading={loading}
                    refetch={refetch}
                    // @ts-expect-error
                    errorMessage={safelyGetGraphQLErrorMessage(error)}
                />
            );
        }}
    </StageQuery>
);
